<template>
  <div id="app" class="u-font-md">
    <router-view/>
    <PublicFooter />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PublicFooter from './components/PublicFooter';
export default {
  components: { PublicFooter },
  data() {
    return {};
  },
  methods: {
    // 初始化数据
    init() {
      this.getDistrictList();
      this.getIndustryList();
      this.getDomainList();
      this.getScaleIndustryList();
    },
    ...mapActions('pageOptions', ['getDistrictList', 'getIndustryList', 'getDomainList', 'getScaleIndustryList'])
  },
  created () {
    this.init();
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir,"Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #303133;
}
</style>
